// @ts-strict-ignore
import React from 'react';
import { Text } from '@usealloy/component-library';
import {
  NOT_VALID_KEY,
  VALID_KEY,
  validityBadgeTextConfig,
  validityBadgeUiConfig,
} from 'flow/editor/components/thresholds/IsolatedTextEditingContainer/constants';
import type { ThresholdRightAttributeOrigin } from 'flow/editor/components/NodeEditorDrawer/types';
import { StyledBadge, StyledHyperlinkText } from './styles';

interface ValidityBadgeProps {
  isValid: boolean;
  originType: ThresholdRightAttributeOrigin;
  leftDataType: string;
}

const ValidityBadge = ({ isValid, originType, leftDataType }: ValidityBadgeProps) => {
  const validityKey = isValid ? VALID_KEY : NOT_VALID_KEY;

  const uiDetails = validityBadgeUiConfig[validityKey];
  const textDetails = validityBadgeTextConfig[originType][leftDataType];
  const text = textDetails[validityKey];

  // not yet configured
  if (!text) return null;

  return (
    <StyledBadge
      icon={uiDetails.icon}
      iconSize="small"
      backgroundColor={uiDetails.backgroundColor}
    >
      <Text size={1}>{text}</Text>
      {
        textDetails.hyperlink && (
          <a
            className="secondary"
            href={textDetails.hyperlink.link}
            target="_blank"
            rel="noreferrer"
          >
            <StyledHyperlinkText size={1}>
              {textDetails.hyperlink.text}
            </StyledHyperlinkText>
          </a>
        )
      }
    </StyledBadge>
  );
};

export default ValidityBadge;
